import axios from 'axios';
import {
  FETCH_PROFILE_FAILURE,
  FETCH_PROFILE_REQUEST,
  FETCH_PROFILE_SUCCESS,
  SEND_CONTACT_FAILURE,
  SEND_CONTACT_REQUEST,
  SEND_CONTACT_SUCCESS,
  SIGNOUT,
  UPDATE_PROFILE_FAILURE,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
} from './actionTypes';

export function getMe(token) {
  return dispatch => {
    dispatch({ type: FETCH_PROFILE_REQUEST });
    return axios({
      url: `${process.env.GATSBY_API_URL}/user/me`,
      method: 'get',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(response => {
        dispatch({ type: FETCH_PROFILE_SUCCESS, payload: response.data });
      })
      .catch(error => {
        dispatch({ type: FETCH_PROFILE_FAILURE, payload: error });
      });
  };
}

export function updateMe(token, firstName, lastName, email, phone, password, file, callback, fallback) {
  return dispatch => {
    dispatch({ type: UPDATE_PROFILE_REQUEST });
    const updateProfileData = image =>
      axios({
        url: `${process.env.GATSBY_API_URL}/user/me`,
        method: 'put',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: {
          firstName,
          lastName,
          local: { email },
          phone,
          image,
        },
      })
        .then(response => {
          dispatch({ type: UPDATE_PROFILE_SUCCESS, payload: response.data });
          if (callback) callback();
        })
        .catch(error => {
          dispatch({ type: UPDATE_PROFILE_FAILURE, payload: error });
          if (fallback) fallback();
        });
    if (file) {
      const form = new FormData();
      form.append('image', file);
      axios({
        url: `${process.env.GATSBY_API_URL}/storage/image/upload`,
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
        data: form,
      })
        .then(({ data }) => updateProfileData(data))
        .catch(error => {
          dispatch({ type: UPDATE_PROFILE_FAILURE, payload: error });
          if (fallback) fallback();
        });
    } else {
      updateProfileData();
    }
  };
}

export function updateData(token, email, phone, blocked, deleted, callback, fallback) {
  return dispatch => {
    dispatch({ type: UPDATE_PROFILE_REQUEST });
    axios({
      url: `${process.env.GATSBY_API_URL}/user/me`,
      method: 'put',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: {
        local: { email },
        phone: phone,
        blocked: blocked,
        deleted: deleted,
      },
    })
      .then(response => {
        dispatch({ type: UPDATE_PROFILE_SUCCESS, payload: response.data });
        if (callback) callback();
        if (blocked || deleted) {
          dispatch({ type: SIGNOUT });
        }
      })
      .catch(error => {
        dispatch({ type: UPDATE_PROFILE_FAILURE, payload: error });
        if (fallback) fallback();
      });
  };
}

export function unlinkFacebook(token, callback, fallback) {
  return dispatch => {
    dispatch({ type: UPDATE_PROFILE_REQUEST });
    axios({
      url: `${process.env.GATSBY_API_URL}/user/me/unlink/facebook`,
      method: 'put',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then(response => {
        dispatch({ type: UPDATE_PROFILE_SUCCESS, payload: response.data });
        if (callback) callback();
      })
      .catch(error => {
        dispatch({ type: UPDATE_PROFILE_FAILURE, payload: error });
        if (fallback) fallback();
      });
  };
}

export function sendContact(token, name, email, subject, text) {
  return dispatch => {
    dispatch({ type: SEND_CONTACT_REQUEST });
    return axios({
      url: `${process.env.GATSBY_API_URL}/contact`,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        name: name,
        from: email,
        subject: subject,
        text: text,
      },
    })
      .then(response => {
        dispatch({ type: SEND_CONTACT_SUCCESS, payload: response.data });
      })
      .catch(e => {
        dispatch({ type: SEND_CONTACT_FAILURE, payload: error });
        console.error(e);
      });
  };
}

export function updateMeBooking(token, phone, email, callback) {
  return dispatch => {
    dispatch({ type: UPDATE_PROFILE_REQUEST });

    return axios({
      url: `${process.env.GATSBY_API_URL}/user/me`,
      method: 'put',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: { phone, local: { email } },
    })
      .then(response => {
        dispatch({ type: UPDATE_PROFILE_SUCCESS, payload: response.data });
        callback();
      })
      .catch(error => {
        dispatch({ type: UPDATE_PROFILE_FAILURE, payload: error });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/ProfilAction.js